import { useCallback, useEffect, useState } from "react";
import { Offcanvas, Spinner } from "react-bootstrap";
import { ControllerCreateCliente } from "../../Service/Service.cliente";
import Swal from "sweetalert2";
import { ListarTipoDocumento } from "../../Service/Service.tipoDocumento";
import SelectSearchable from "../SelectSeachble/SelectSearchble";
import { GetTokenDecoded } from "../../utils/storeUsuario";

const OffcanvasCliente = ({ data }) => {

    const { showCliente, handleCloseCliente } = data;
    const [loading, setLoading] = useState(false);
    const [tipoDocumentos, setTipoDocumentos] = useState([]);
    const [selectedTipoDocOption, setSelectedTipoDocOption] = useState(null);

    const [cliente, setCliente] = useState({
        idcliente: 0,
        idclinica: 0,
        nombre: "",
        tipoID: "",
        identificacion: "",
        // FACTURA-CLIENTE-JURIDICO-FIX-01: campo alineado con la columna BD y el
        // contrato backend (`es_juridica`). Antes era `es_juridico` -> no se
        // persistía y los clientes jurídicos quedaban como persona natural.
        es_juridica: false,
        direccion: "",
        correo: "",
        celular: "",
        telefono: "",
        tipo_documento: "",
    });

    const isFormValid = () => {
        return cliente.nombre.trim() !== "" &&
            cliente.identificacion.trim() !== "" &&
            cliente.correo.trim() !== "" &&
            cliente.tipo_documento !== "" &&
            cliente.direccion.trim() !== "";
    };

    const sendFormHandleCliente = async () => {

        try {
            setLoading(true);

            const response = await ControllerCreateCliente({
                ...cliente,
                idclinica: GetTokenDecoded()?.idclinica,
                es_juridica: cliente.es_juridica ? 1 : 0,
            });
            if (!response || !response.success) {
                throw new Error(response?.message || "No se pudo crear el cliente. Revisa los datos e inténtalo de nuevo.");
            }
            Swal.fire({
                icon: "success",
                title: "Éxito",
                text: response.message,
                timer: 1500,
                showConfirmButton: false,
            });            

        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: error.message || "Hubo un error al crear cliente",
            });

        } finally {
            handleCloseCliente();
            setLoading(false);
        }
    }

    const handleChangeTipoDoc = selectedTipoDocOption => {
        setSelectedTipoDocOption(selectedTipoDocOption);
        setCliente({
            ...cliente,
            tipo_documento: selectedTipoDocOption.value
        })
    };

    const fetchInitialData = useCallback(async () => {
        const documentos = await ListarTipoDocumento();
        if (documentos.success) {
            setTipoDocumentos(documentos.data.map(d => ({ value: d.idtipodocumento, label: d.tipo })))
        }

    }, []);

    useEffect(() => {
        if (showCliente) {
            fetchInitialData();
        }
    }, [showCliente]);

    return (
        <Offcanvas keyboard={false}
            show={showCliente}
            onHide={handleCloseCliente}
            placement="end"
            style={{ zIndex: 10000 }}
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Crear Cliente</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="d-flex flex-column">

                <div className="h-auto">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Nombre *</label>
                                <input type='text'
                                    className='form-control'
                                    value={cliente.nombre}
                                    onChange={(e) => setCliente({ ...cliente, nombre: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Tipo de Documento *</label>
                                <SelectSearchable
                                    listCompany={tipoDocumentos}
                                    handleChange={handleChangeTipoDoc}
                                    selectedOption={selectedTipoDocOption}
                                    placeholder="Seleccione"
                                    isMulti={false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Identificaci&oacute;n *</label>
                                <input type='text' className='form-control' value={cliente.identificacion} onChange={(e) => setCliente({ ...cliente, identificacion: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4">
                        <div className="col-md-12">
                            <div className='form-check'>
                                <label>Es Jurídico</label>
                                <input type='checkbox' className='form-check-input' checked={cliente.es_juridica} onChange={(e) => setCliente({ ...cliente, es_juridica: e.target.checked })} />
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Direcci&oacute;n *</label>
                                <input type='text' className='form-control' value={cliente.direccion} onChange={(e) => setCliente({ ...cliente, direccion: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label>Correo *</label>
                                <input type='text' className='form-control' value={cliente.correo} onChange={(e) => setCliente({ ...cliente, correo: e.target.value })} />
                            </div>
                        </div>
                    </div>

                    <div className="row pt-4">
                        <div className="col-md-12">
                            <div className="form-group pb-4">
                                <label>Tel&eacute;fono</label>
                                <input type='text' className='form-control' value={cliente.telefono} onChange={(e) => setCliente({ ...cliente, telefono: e.target.value })} />
                            </div>
                        </div>
                    </div>
                </div>


                <div className="p-3 w-100 text-center mt-4">
                    <button className="btn btn-primary w-100"
                        onClick={sendFormHandleCliente}
                        disabled={!isFormValid() || loading}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                {" "}Por favor espere...
                            </>
                        ) : "Crear"}
                    </button>
                </div>

            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default OffcanvasCliente;